import { Auth0Provider } from "@auth0/auth0-react"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import ReactDOM from "react-dom"
import { HelmetProvider } from "react-helmet-async"
import { ProSidebarProvider } from "react-pro-sidebar"
import { Provider } from "react-redux"
import { BrowserRouter } from "react-router-dom"
import { App } from "./App"
import { getConfig } from "./helpers/Auth0/config_helper"
import * as serviceWorker from "./serviceWorker"
import { store } from "./store"

const queryClient = new QueryClient()

const config = getConfig()
const providerConfig = {
  domain: config.domain,
  clientId: config.clientId,
  ...(config.audience ? { audience: config.audience } : null),
  cacheLocation: "localstorage" as const,
  useRefreshTokens: true,
  redirectUri: window.location.origin,
}

const app = (
  <Auth0Provider {...providerConfig}>
    <HelmetProvider>
      <Provider store={store}>
        <BrowserRouter>
          <ProSidebarProvider>
            <QueryClientProvider client={queryClient}>
              <App />
            </QueryClientProvider>
          </ProSidebarProvider>
        </BrowserRouter>
      </Provider>
    </HelmetProvider>
  </Auth0Provider>
);

ReactDOM.render(app, document.getElementById("root"))
serviceWorker.unregister()
